import { FunctionFactory } from 'survey-core';

/** Enables the survey to programmatically get the day. */
const CustomizeSurveyAvailability = () => {
  const getDay = (params) => {
    if (!params && params.length < 1) return null;
    if (!params[0]) return null;
    return params[0].getDay();
  };

  FunctionFactory.Instance.register('getDay', getDay);
};

export default CustomizeSurveyAvailability;
